import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

import { SUPPLEMENTS_PATH } from './constants'

export default async function fetchCountByPeriod(policyPeriodId: number): Promise<number> {
  const api = ApiClient()

  const response = await api.get(SUPPLEMENTS_PATH, { policy_period_id: policyPeriodId })

  return response.count
}
